import { OnInit, ElementRef } from '@angular/core';
import * as Highcharts from 'highcharts/highstock';
import * as hc3d from "highcharts/highcharts-3d";
import { ChartService } from '../services/chart.service';
import { Globals } from '../objects/Globals';
import { ThemeSettingService } from '../services/theme-setting.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { MainLoadingService } from '../services/main-loading.service';
import { ModalControlComponent } from '../modal-control/modal-control.component';
import { WorkspaceService } from '../services/workspace.service';
import { ContextMenuService, ContextMenuComponent } from 'ngx-contextmenu';
import HC_data from 'highcharts/modules/data';
import HC_accessibility from 'highcharts/modules/accessibility';
import { SummaryService } from '../services/summary.service';
import { EnvService } from '../env.service';
HC_data(Highcharts);
HC_accessibility(Highcharts);
hc3d(Highcharts);
Highcharts.setOptions({
    lang: {
        thousandsSep: ","
    }
});
var ChartComponent = /** @class */ (function () {
    function ChartComponent(elementRef, globals, chartService, themeSettingService, modalService, mainLoadingService, workspaceService, contextMenuService, summaryService, env) {
        var _this = this;
        this.elementRef = elementRef;
        this.globals = globals;
        this.chartService = chartService;
        this.themeSettingService = themeSettingService;
        this.modalService = modalService;
        this.mainLoadingService = mainLoadingService;
        this.workspaceService = workspaceService;
        this.contextMenuService = contextMenuService;
        this.summaryService = summaryService;
        this.env = env;
        this.isBusy = false;
        this.Highcharts = Highcharts; // required
        this.chartConstructor = 'chart'; // optional string, defaults to 'chart'
        this.updateFlag = false; // optional boolean
        this.oneToOneFlag = true; // optional boolean, defaults to false
        this.showExpand = false;
        this.isExpandChart = false;
        this.filledSpace = 0;
        this.showExpand = this.env.chartExpand;
        this.chartService.chartRefreshChanged$.subscribe(function (result) {
            if (result) {
                // console.log(result);
                // var temp = this.chartObject
                // this.isBusy = true;
                // this.chartObject = null;
                // setTimeout(() => {
                //   this.chartObject = JSON.parse(JSON.stringify(temp));
                //   this.isBusy = false
                //   // Object.assign({}, temp);
                // },)
            }
        });
        this.summaryService.summaryUpdateChanged$.subscribe(function (result) {
            if (result) {
                setTimeout(function () {
                    _this.playSound();
                    _this.updateFlag = true;
                }, 1000);
            }
        });
    }
    Object.defineProperty(ChartComponent.prototype, "setComponentId", {
        set: function (id) {
            this.componentId = id;
            if (this.componentId) {
                this.refreshChartCard();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChartComponent.prototype, "setChartObject", {
        set: function (chart) {
            this.isBusy = false;
            if (chart) {
                this.chartObject = {
                    chartOptions: {},
                    currentChart: 1,
                    totalCharts: 1
                };
                this.chartObject.chartOptions = JSON.parse(chart);
                // this.chartObject.chartOptions["navigator"] = {};
                // this.chartObject.chartOptions["navigator"]["enabled"] = true;
                // this.chartObject.chartOptions["chart"]["style"]["fontFamily"] = "Lato, sans-serif, Arial, Helvetica";
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChartComponent.prototype, "setChartLoading", {
        set: function (isLoading) {
            this.isBusy = isLoading;
        },
        enumerable: true,
        configurable: true
    });
    ChartComponent.prototype.hasPrevious = function () {
        return (this.chartObject != null && this.currentChart != 1);
    };
    ChartComponent.prototype.hasNext = function () {
        return (this.chartObject != null && this.currentChart != this.totalCharts);
    };
    ChartComponent.prototype.nextChart = function (event) {
        var _this = this;
        this.isBusy = true;
        this.backupChartObject = this.chartObject;
        this.chartObject = null;
        this.chartService.nextChart(this.componentId).subscribe(function (result) {
            if (result == "1") {
                _this.refreshChartCard();
            }
        });
    };
    ChartComponent.prototype.previousChart = function (event) {
        var _this = this;
        this.isBusy = true;
        this.backupChartObject = this.chartObject;
        this.chartObject = null; // to avoid error merging the object
        this.chartService.previousChart(this.componentId).subscribe(function (result) {
            if (result == "1") {
                _this.refreshChartCard();
            }
        });
    };
    ChartComponent.prototype.refreshChartCard = function () {
        var _this = this;
        this.isBusy = true;
        this.chartService.getChart(this.componentId).subscribe(function (chart) {
            var chartObject = JSON.parse(chart);
            _this.previousComponentId = _this.componentId;
            _this.chartObject = chartObject;
            if (_this.chartObject.chartOptions) {
                if (_this.chartObject.chartOptions["series"][0]["type"] == "area") {
                    _this.chartObject.chartOptions["plotOptions"]["area"]["point"]["events"]["click"] = _this.GetChartData.bind(_this);
                }
                else {
                    _this.chartObject.chartOptions["plotOptions"]["series"]["point"]["events"]["click"] = _this.GetChartData.bind(_this);
                }
                _this.chartObject.chartOptions["yAxis"]["labels"] = {};
                _this.chartObject.chartOptions["yAxis"]["labels"]["formatter"] = _this.formatLabel.bind(_this);
            }
            _this.totalCharts = _this.chartObject.totalCharts;
            _this.currentChart = _this.chartObject.currentChart;
            // this.chartObject.chartOptions["chart"]["width"] = null;["chart"]["width"] = null;
            // this.chartObject.chartOptions["chart"]["height"] = null; //percentage off the width
            // this.chartObject.chartOptions["chart"]["marginLeft"] = "150";
            // this.chartObject.chartOptions["chart"]["marginRight"] = "100";
            _this.isBusy = false;
        }, function (error) {
            _this.isBusy = false;
            _this.chartObject = _this.backupChartObject;
        });
    };
    ChartComponent.prototype.ngOnInit = function () {
        this.loaderConfig = this.themeSettingService.getTheme();
        // setTimeout(() => {
        //   if (!this.componentId) this.isBusy = false;
        // }, 5000)
    };
    ChartComponent.prototype.onContextMenu = function ($event, item) {
        if ($event.button == 0) {
            this.contextMenuService.show.next({
                contextMenu: this.basicMenu,
                event: $event,
                item: item,
            });
        }
        $event.preventDefault();
        $event.stopPropagation();
    };
    ChartComponent.prototype.GetChartData = function (e) {
        var _this = this;
        var p = e.point;
        this.mainLoadingService.setLoading(true);
        var category = encodeURIComponent(p.category);
        if (p.series.userOptions.type == "pie") {
            category = encodeURIComponent(p.name);
        }
        else if (p.series.userOptions.type == "area") {
            category = p.series.name;
        }
        this.chartService.getChartData(this.componentId, p.series.name, category).subscribe(function (result) {
            _this.mainLoadingService.setLoading(false);
            if (result) {
                _this.openSummaryPopup(result);
            }
        }, function (error) {
            _this.mainLoadingService.setLoading(false);
        });
    };
    ChartComponent.prototype.formatLabel = function (e) {
        if (e.value >= 1000000000) {
            return (e.value / 1000000000) + 'B';
        }
        else if (e.value >= 1000000) {
            return (e.value / 1000000) + 'M';
        }
        else if (e.value >= 1000) {
            return (e.value / 1000) + 'K';
        }
        else {
            return e.value;
        }
    };
    ChartComponent.prototype.openSummaryPopup = function (id) {
        var _this = this;
        var config = {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-dialog-centered modal-control',
            initialState: {
                componentId: id,
                title: "Report View",
                popupTitle: "Report View",
                type: "summary"
            }
        };
        if (this.modalService.getModalsCount() > 0) {
            document.querySelectorAll('.modal.fade').item(this.modalService.getModalsCount() - 1).classList.remove('show');
        }
        this.modalService.onHide.subscribe(function (reason) {
            if (_this.modalService.getModalsCount() > 0) {
                document.querySelectorAll('.modal.fade').item(_this.modalService.getModalsCount() - 1).classList.add('show');
            }
        });
        this.modalRef = this.modalService.show(ModalControlComponent, config);
    };
    ChartComponent.prototype.showAll = function () {
        var _this = this;
        //show whole data
        this.mainLoadingService.setLoading(true);
        this.chartService.getFullChartData(this.componentId).subscribe(function (result) {
            _this.mainLoadingService.setLoading(false);
            if (result) {
                _this.openSummaryPopup(result);
            }
        }, function (error) {
            _this.mainLoadingService.setLoading(false);
        });
    };
    ChartComponent.prototype.expandChart = function () {
        var _this = this;
        this.chartService.expandChart(this.componentId).subscribe(function (result) {
            var config = {
                keyboard: false,
                ignoreBackdropClick: true,
                class: 'modal-dialog-centered modal-control',
                initialState: {
                    componentId: result,
                    title: "Report View",
                    popupTitle: "",
                    type: "chart"
                }
            };
            if (_this.modalService.getModalsCount() > 0) {
                document.querySelectorAll('.modal.fade').item(_this.modalService.getModalsCount() - 1).classList.remove('show');
            }
            _this.modalService.onHide.subscribe(function (reason) {
                if (_this.modalService.getModalsCount() > 0) {
                    document.querySelectorAll('.modal.fade').item(_this.modalService.getModalsCount() - 1).classList.add('show');
                }
            });
            _this.modalRef = _this.modalService.show(ModalControlComponent, config);
        });
    };
    ChartComponent.prototype.playSound = function () {
        var audio = new Audio("assets/sound/inflicted.mp3");
        audio.muted = false;
        audio.play();
    };
    return ChartComponent;
}());
export { ChartComponent };
